import { useAllhomesApi } from '../export';
const usePageContext = pageKey => {
  const _useAllhomesApi = useAllhomesApi(),
    _useAllhomesApi$pageC = _useAllhomesApi.pageContext,
    pageContext = _useAllhomesApi$pageC === void 0 ? {} : _useAllhomesApi$pageC,
    updatePageContext = _useAllhomesApi.updatePageContext;
  const thisContext = pageContext[pageKey] || {};
  const updateThisContext = newValue => {
    updatePageContext(pageKey, newValue);
  };
  return [thisContext, updateThisContext];
};
export default usePageContext;